import { createFeatureSelector, createSelector } from '@ngrx/store';

import { PlanEditState } from './plan-edit.state';

export const selectPlanEditState = createFeatureSelector<PlanEditState>('planEdit');

export const selectPlanEditLastRevision = createSelector(
  selectPlanEditState,
  (state) => state.lastRevision
);

export const selectPlanWatch = createSelector(selectPlanEditState, (state) => state.watch);
